import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CitytownService {

  constructor(private  httpClient: HttpClient) {
  }

  getCitytowns() {
    return this.httpClient.get('/systemconfig/citytown/');
  }


  ///////////////////old/////////////////
  getCitytown(id) {
    return this.httpClient.get(`/systemconfig/citytown/${id}/`);
  }

  getCity(id){
    return this.httpClient.get('/systemconfig/cities/',{params : {id:id}})
  }

  postCitytown(citytown) {
    return this.httpClient.post('/systemconfig/citytown/', citytown);
  }

  /////////////////////////old//////////////////
  updateCitytown(id, citytown) {
    return this.httpClient.patch(`/systemconfig/citytown/${id}/`, citytown);
  }

  updateCity(city){
  return this.httpClient.post('/systemconfig/cities/',city)
  }

  postCitytownFile(file) {
    return this.httpClient.post('/systemconfig/importcitytown/', file);
  }

  checkCity(city){
    return this.httpClient.get('/systemconfig/checkcity/?city='+ city);
  }

  getCityData(district){
    return this.httpClient.get('/systemconfig/getcitydata/?district='+ district);
  }

  getAllCities() {
    return this.httpClient.get('/systemconfig/cities/');
  }
}
